"use strict";
/**
 * Email and text-message alerts (Anthony, 10/9 call): the phone number in Profile,
 * the SMS consent wording, and the per-channel alert table in Notifications.
 *
 * One copy for web and mobile because the consent sentence is a legal record: the
 * server stamps `sms_consent_at` when the box is ticked, and both clients must have
 * shown the same words at that moment. Changing SMS_CONSENT_COPY changes what users
 * agree to, so it also changes the 10DLC campaign registration (backend/DEPLOY.md).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_ALERTS = exports.PHONE_NUMBER_HELP = exports.SMS_CONSENT_COPY = void 0;
exports.smsUnavailableReason = smsUnavailableReason;
exports.formatUsPhone = formatUsPhone;
exports.isValidUsPhone = isValidUsPhone;
/** Shown beside the consent checkbox. CTIA asks for the brand, the frequency, the
 *  rates line and how to stop, in the place consent is given. */
exports.SMS_CONSENT_COPY = "Text me Fomo-Fi alerts at this number. Message frequency varies with your alerts. Message and data rates may apply. Reply STOP to opt out or HELP for help.";
exports.PHONE_NUMBER_HELP = "US mobile numbers only. Used for the text alerts you choose in Notifications, and nothing else.";
/** The three alerts the agreement promises, which are the only ones sent by email or
 *  text. Keys are the server's per-channel field suffixes. */
exports.CHANNEL_ALERTS = [
    { suffix: "upcoming_bills", label: "Upcoming bills" },
    { suffix: "budget_alerts", label: "Budget alerts" },
    { suffix: "cashflow_warnings", label: "Cash flow warnings" },
];
/** What the Text column says when it cannot be used yet, or null when it can. */
function smsUnavailableReason(state) {
    if (!state.phoneNumber)
        return "Add a mobile number in Profile to get text alerts.";
    if (!state.smsConsent)
        return "Agree to text alerts in Profile to turn them on.";
    return null;
}
/** Digits only, without a leading US country code. */
function nationalDigits(raw) {
    const digits = (raw || "").replace(/\D/g, "");
    return digits.length === 11 && digits.startsWith("1")
        ? digits.slice(1)
        : digits;
}
/**
 * "+15125550142" or a half-typed "51255" as a person reads it: "(512) 555-0142",
 * "(512) 55". Formats as the user types; the server's normalize_us_phone decides.
 */
function formatUsPhone(raw) {
    const d = nationalDigits(raw).slice(0, 10);
    if (d.length === 0)
        return "";
    if (d.length <= 3)
        return `(${d}`;
    if (d.length <= 6)
        return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
/** Mirrors the server's check (apps/notifications/phone.py): a 10-digit NANP number. */
function isValidUsPhone(raw) {
    const trimmed = (raw || "").trim();
    if (trimmed.startsWith("+") && !trimmed.startsWith("+1"))
        return false;
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(nationalDigits(trimmed));
}
//# sourceMappingURL=alertChannelsCopy.js.map